import { useContext, useEffect, useRef, useState } from 'react';
import { ViContext } from '../../context/ViContext';
import { MapContext } from '../../context/MapContext';
import RadarChart from './RadarChart';

import axios from 'axios';

import { Radar } from 'react-chartjs-2';

function ResultWrap() {
	const { tabInfoArr, selectedTab } = useContext(ViContext);
	const { makeVectorUrl } = useContext(MapContext);
	const [resultWrapOpen, setResultWrapOpen] = useState(false);
	const [resultValues, setResultValues] = useState({});
	const [chartData, setChartData] = useState({});
	const [chartOption, setChartOption] = useState({});

	useEffect(() => {
		// if (tabInfoArr[selectedTab].sggCode !== '') {
		if (tabInfoArr[selectedTab].emdCode === '') {
			let sido_code = tabInfoArr[selectedTab].sidoCode;
			let sgg_code = tabInfoArr[selectedTab].sggCode;
			let pop = tabInfoArr[selectedTab].pop;
			let consume = tabInfoArr[selectedTab].consume;
			let prod = tabInfoArr[selectedTab].prod;
			axios({
				method: 'GET',
				url: `${process.env.REACT_APP_CONTEXT_PATH}/interactive/api/vi/analysisResult.json?sido_code=${sido_code}&sgg_code=${sgg_code}&pop=${pop}&consume=${consume}&prod=${prod}`,
			})
				.then((res) => {
					setResultValues(res.data.data);
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			let sido_code = tabInfoArr[selectedTab].emdCode.substring(0, 2);
			let sgg_code = tabInfoArr[selectedTab].emdCode.substring(0, 5);
			let emd_code = tabInfoArr[selectedTab].emdCode;
			let pop = tabInfoArr[selectedTab].pop;
			let consume = tabInfoArr[selectedTab].consume;
			let prod = tabInfoArr[selectedTab].prod;
			axios({
				method: 'GET',
				url: `${process.env.REACT_APP_CONTEXT_PATH}/interactive/api/vi/analysisResult.json?sido_code=${sido_code}&sgg_code=${sgg_code}&emd_code=${emd_code}&pop=${pop}&consume=${consume}&prod=${prod}`,
			})
				.then((res) => {
					setResultValues(res.data.data);
				})
				.catch((error) => {
					console.log(error);
				});
		}
		// } else {
		// 	axios({
		// 		method: 'GET',
		// 		url: `${process.env.REACT_APP_CONTEXT_PATH}/interactive/api/vi/analysisResult.json?sido_code=11&sgg_code=11110&pop=1&consume=1&prod=1`,
		// 	})
		// 		.then((res) => {
		// 			setChartData({
		// 				labels: [
		// 					'지역활력지수(가중치 적용)',
		// 					'지역활력지수(기존)',
		// 					'인구활력도',
		// 					'소비활력도',
		// 					'생산활력도',
		// 				],
		// 				datasets: [
		// 					{
		// 						label: '전국 평균',
		// 						data: [
		// 							res.data.data.korea_average.processViAvg,
		// 							res.data.data.korea_average.originViAvg,
		// 							res.data.data.korea_average.popAvg,
		// 							res.data.data.korea_average.consumeAvg,
		// 							res.data.data.korea_average.prodAvg,
		// 						],
		// 						backgroundColor: ['rgba(255, 99, 132, 0.2)'],
		// 						borderColor: ['rgb(255, 99, 132)'],
		// 						borderWidth: 1,
		// 					},
		// 				],
		// 			});
		// 			setChartOption({
		// 				responsive: true,
		// 				plugins: {
		// 					title: {
		// 						display: true,
		// 						text: '전국',
		// 					},
		// 				},
		// 				scales: {
		// 					r: {
		// 						ticks: {
		// 							font: {
		// 								weight: 600,
		// 							},
		// 							backdropColor: 'rgba(255, 255, 255, 0)',
		// 							z: 5,
		// 						},
		// 					},
		// 				},
		// 			});
		// 		})
		// 		.catch((error) => {
		// 			console.log(error);
		// 		});
		// }
	}, [tabInfoArr[selectedTab]]);

	useEffect(() => {
		if (!!Object.keys(resultValues).length) {
			const _chartData = {
				labels: [
					'지역활력지수(가중치 적용)',
					'지역활력지수(기존)',
					'인구활력도',
					'소비활력도',
					'생산활력도',
				],
				datasets: [],
			};
			if (resultValues.korea_average) {
				_chartData.datasets.push({
					label: '전국 평균',
					data: [
						resultValues.korea_average.processViAvg,
						resultValues.korea_average.originViAvg,
						resultValues.korea_average.popAvg,
						resultValues.korea_average.consumeAvg,
						resultValues.korea_average.prodAvg,
					],
					backgroundColor: ['rgba(255, 99, 132, 0.2)'],
					borderColor: ['rgb(255, 99, 132)'],
					borderWidth: 1,
				});
			}

			if (tabInfoArr[selectedTab].sggCode !== '') {
				if (resultValues.jurisdiction_average) {
					_chartData.datasets.push({
						label: '관내 평균',
						data: [
							resultValues.jurisdiction_average.processViAvg,
							resultValues.jurisdiction_average.originViAvg,
							resultValues.jurisdiction_average.popAvg,
							resultValues.jurisdiction_average.consumeAvg,
							resultValues.jurisdiction_average.prodAvg,
						],
						backgroundColor: ['rgba(112, 135, 235, 0.2)'],
						borderColor: ['rgb(112, 135, 235)'],
						borderWidth: 1,
					});
				}

				if (resultValues.select_area) {
					_chartData.datasets.push({
						label: '선택 지역',
						data: [
							resultValues.select_area.processVi,
							resultValues.select_area.originVi,
							resultValues.select_area.pop,
							resultValues.select_area.consume,
							resultValues.select_area.prod,
						],
						backgroundColor: ['rgba(121, 213, 98, 0.2)'],
						borderColor: ['rgb(121, 213, 98)'],
						borderWidth: 1,
					});
				}
			}

			setChartData(_chartData);

			let title = resultValues.select_area
				? resultValues.select_area.ctpvNm + ' ' + resultValues.select_area.sggNm
				: tabInfoArr[selectedTab].sggCode === ''
				? tabInfoArr[selectedTab].sidoName
				: '전국';
			if (resultValues.select_area?.emdNm) {
				title += ` ${resultValues.select_area.emdNm}`;
			}
			setChartOption({
				responsive: true,
				plugins: {
					title: {
						display: true,
						text: title,
					},
				},
				scales: {
					r: {
						ticks: {
							font: {
								weight: 600,
							},
							backdropColor: 'rgba(255, 255, 255, 0)',
							z: 5,
						},
					},
				},
			});
		}
	}, [resultValues]);

	const onClickTr = (code) => {
		if (code.length === 5) {
			makeVectorUrl(code, 'sgg_cd');
		} else if (code.length === 7) {
			makeVectorUrl(code, 'amd_cd');
		}
	};
	const getResultTable = () => {
		console.log(resultValues);
		if (Object.keys(resultValues).length === 0) return;
		return (
			<table>
				<thead>
					<tr>
						<th>순위(기존)</th>
						<th>순위(가중치 적용)</th>
						<th>{resultValues.select_area?.emdNm ? '읍면동' : '시군구'}</th>
						<th>지역활력지수(기존)</th>
						<th>지역활력지수(가중치 적용)</th>
						<th>인구활력도</th>
						<th>소비활력도</th>
						<th>생산활력도</th>
					</tr>
				</thead>
				<tbody>
					{resultValues.table_data.map((cur, idx) => {
						return (
							<tr
								key={resultValues.select_area?.emdNm ? cur.admCd : cur.sggCd}
								onClick={(e) =>
									onClickTr(
										resultValues.select_area?.emdNm ? cur.admCd : cur.sggCd
									)
								}
							>
								<td>{cur.rank}</td>
								<td>{cur.processRank}</td>
								<td>
									{resultValues.select_area?.emdNm ? cur.emdNm : cur.sggNm}
								</td>
								<td>{cur.originVi}</td>
								<td>{cur.processVi}</td>
								<td>{cur.pop}</td>
								<td>{cur.consume}</td>
								<td>{cur.prod}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	return (
		<div className={resultWrapOpen ? 'resultWrap' : 'resultWrap hide'}>
			<div
				className="hideBtn"
				onClick={() => setResultWrapOpen(!resultWrapOpen)}
			>
				<img src="./img/leftMenuHideBtn.png" alt="닫기" />
			</div>
			<div className="resultContent">
				<div className="chartArea">
					{!!Object.keys(chartData).length ? (
						<Radar type="Radar" data={chartData} options={chartOption} />
					) : (
						<div>가중치를 변경 및 적용 시 분석결과가 표시됩니다.</div>
					)}
				</div>
				<div className="tableArea">{getResultTable()}</div>
			</div>
		</div>
	);
}

export default ResultWrap;
